/**
 * Design-токены публичной витрины — тёмная фермерская эстетика.
 * Палитра: глубокий чёрно-зелёный фон + зелёный акцент #7AB547.
 */
import { cn } from '~/lib/utils'

export const SITE_COLORS = {
  bg:              '#09100a',   // основной фон страниц
  surface:         '#111d12',   // поверхности карточек
  surfaceHover:    '#182619',   // ховер карточек
  surfaceElevated: '#1e3020',   // попапы / модалки
  border:          'rgba(122,181,71,0.18)',
  borderStrong:    'rgba(122,181,71,0.35)',
  accent:          '#7AB547',
  accentHover:     '#6ba03e',
  accentDim:       'rgba(122,181,71,0.12)',
  text:            '#f4f8f1',
  textMuted:       '#dfe8d8',
  textSubtle:      '#b9cdb0',
  heading:         '#ffffff',
} as const

export const siteContainerClass = 'mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8'

export const siteHeadingClass =
  'text-2xl font-bold tracking-tight text-white sm:text-3xl'

export const siteBtnPrimaryClass =
  'inline-flex items-center justify-center gap-2 rounded-xl bg-[#7AB547] px-6 py-3 text-sm font-semibold text-[#09100a] transition-all hover:bg-[#6ba03e] hover:shadow-lg hover:shadow-[#7AB547]/25 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#7AB547] active:scale-[0.97] disabled:opacity-40 disabled:pointer-events-none'

export const siteBtnOutlineClass =
  'inline-flex items-center justify-center gap-2 rounded-xl border border-[#7AB547]/40 px-6 py-3 text-sm font-semibold text-white transition-all hover:border-[#7AB547] hover:bg-[#7AB547]/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#7AB547] active:scale-[0.97]'

export const siteCardClass =
  'rounded-2xl border border-[rgba(122,181,71,0.18)] bg-[#111d12] transition-all hover:border-[rgba(122,181,71,0.35)] hover:bg-[#182619] hover:shadow-xl hover:shadow-[#7AB547]/10'

export const siteInputClass =
  'w-full rounded-xl border border-[rgba(122,181,71,0.25)] bg-[#111d12] px-4 py-3 text-[#f4f8f1] placeholder:text-[#b9cdb0] transition-colors focus:border-[#7AB547] focus:outline-none focus:ring-2 focus:ring-[#7AB547]/25'

/** Числовой input без стандартных стрелок браузера (± задаём сами) */
export const siteNumberInputNoSpinnerClass =
  '[appearance:textfield] [-moz-appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none'

export function siteLinkClass(extra?: string) {
  return cn('text-[#7AB547] transition-colors hover:text-[#6ba03e] hover:underline', extra)
}

export const siteDialogOverlayClass =
  'fixed inset-0 z-[60] bg-black/75 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out'

export const siteDialogContentClass =
  'fixed left-1/2 top-1/2 z-[61] flex max-h-[min(92vh,900px)] w-[calc(100%-2rem)] max-w-lg -translate-x-1/2 -translate-y-1/2 flex-col overflow-hidden rounded-2xl border border-[rgba(122,181,71,0.25)] bg-[#111d12] shadow-2xl shadow-black/50 outline-none'

export const siteDialogContentWideClass = cn(siteDialogContentClass, 'max-w-4xl')

/** Бейдж «В наличии» / «Нет в наличии» */
export const siteBadgeStock = (inStock: boolean) =>
  inStock
    ? 'inline-flex items-center rounded-full bg-[#7AB547]/15 px-2 py-0.5 text-xs font-medium text-[#7AB547]'
    : 'inline-flex items-center rounded-full bg-red-500/10 px-2 py-0.5 text-xs font-medium text-red-400'
